import Vue from 'vue';

class OptionManager {
  passportId = '';

  fundOptionList = [];

  // 储存分组信息
  fundGroupOptionList = {};

  // 基金加自选需要版本号
  fundVersionCode = 0;

  groupList = [];

  // 获取分组列表
  async getGroupList() {
    if (this.groupList?.length) {
      return this.groupList;
    }
    try {
      const res = await Vue.prototype.$http.useRequests('OptionApi.getGroupList');
      this.groupList = res?.data?.data;
      // this.fundVersionCode = res.data.version;
      return this.groupList;
    } catch (error) {
      throw new Error('获取分组列表失败');
    }
  }

  // 获取基金已自选code
  async getFundOptionList(isForceRefresh = false) {
    try {
      // if (!this.passportId) {
      //   const res = await multi.$user.getUserInfo();
      //   this.passportId = res?.passportid;
      // }
      if (!isForceRefresh && this.fundOptionList?.length) {
        return this.fundOptionList;
      }
      const res = await Vue.prototype.$http.useRequests('OptionApi.getOptionList');
      const { version, zxcodes } = res?.data || {};
      this.fundVersionCode = version;
      this.fundGroupOptionList = zxcodes || {};
      this.fundOptionList = Object.keys(zxcodes);
      return this.fundOptionList;
    } catch (error) {
      return [];
    }
  }

  async getFundGroupOptionList(isForceRefresh = false) {
    try {
      if (!isForceRefresh && Object.keys(this.fundGroupOptionList).length) {
        return this.fundGroupOptionList;
      }
      const res = await Vue.prototype.$http.useRequests('OptionApi.getOptionList');
      const { version, zxcodes } = res?.data || {};
      this.fundVersionCode = version;
      this.fundGroupOptionList = zxcodes || {};
      this.fundOptionList = Object.keys(zxcodes);
      return this.fundGroupOptionList;
    } catch (error) {
      return {};
    }
  }

  // 基金加自选
  async addFundOption(code, groups = []) {
    try {
      if (!this.fundVersionCode) {
        await this.getFundOptionList(true);
      }
      let lastData = '';
      let actionparam = '';
      if (groups.length === 0) {
        actionparam = `-1,${code}`;
      } else {
        // 编辑分组场景 要把已有的分组过滤掉
        const hasGroup = this.fundGroupOptionList[code] || [];
        console.log('hasGroup', hasGroup);
        const notSetGroups = groups.filter((item) => !hasGroup.includes(item));
        actionparam = notSetGroups.map((item) => `${item},${code}`).join(';');
        lastData = `${code}_${hasGroup.sort((a, b) => a - b).join(',')}`;
      }

      const res = await Vue.prototype.$http.useRequests('OptionApi.addOptionFund', {
        actionparam,
        favorversion: this.fundVersionCode,
        lastData,
      });
      if (res?.success) {
        // 操作成功 更新本地数据
        this.fundOptionList.push(code);
        this.fundGroupOptionList[code] = [...(this.fundGroupOptionList[code] || []), ...groups];
        // 更新版本号
        this.fundVersionCode = res?.data?.version;
        this.getFundOptionList(true);
        const webPlatf = multi.$system.webPlatform;
        if (webPlatf === 'wxmp') {
          // eslint-disable-next-line no-undef
          if (wx.miniProgram && wx.miniProgram.postMessage) {
            const { version, zxlist, fcodediscount } = res?.data;
            const data = {
              isGlobal: true,
              eventName: 'option_other_action_done',
              data: {
                easy_fund_add: {
                  version,
                  zxlist,
                  fcodediscount,
                },
              },
            };
            // eslint-disable-next-line no-undef
            wx.miniProgram.postMessage({ data });
          }
        }
      }
      return '';
    } catch (error) {
      // 失败 刷新数据
      await this.getFundOptionList(true);
      return error.errCode === '63116' ? error.errData : '添加自选失败';
    }
  }

  // 基金删自选
  async deleteFundOption(code, groups = []) {
    try {
      // 获取分组信息
      let actionparam = `-1,${code}`;
      let lastData = '';
      if (groups.length === 0) {
        actionparam = this.fundGroupOptionList[code].map((item) => `${item},${code}`).join(';');
      } else {
        actionparam = groups.map((item) => `${item},${code}`).join(';');
        lastData = `${code}_${groups.join(',')}`;
      }
      console.log('actionparam', actionparam);

      const res = await Vue.prototype.$http.useRequests('OptionApi.delOptionFund', {
        actionparam,
        favorversion: this.fundVersionCode,
        lastData,
      });
      if (res?.success) {
        // 操作成功 更新本地数据
        this.fundOptionList = this.fundOptionList.filter((item) => item !== code);
        delete this.fundGroupOptionList[code];
        // 更新版本号
        this.fundVersionCode = res?.data?.version;
        this.getFundOptionList(true);
        const webPlatf = multi.$system.webPlatform;
        if (webPlatf === 'wxmp') {
          // eslint-disable-next-line no-undef
          if (wx.miniProgram && wx.miniProgram.postMessage) {
            const { version } = res?.data;

            const data = {
              isGlobal: true,
              eventName: 'option_other_action_done',
              data: {
                easy_fund_del: { // 插件里才有，兼容weex
                  version,
                  data: actionparam, // -1是分组id，后面的968040是当前基金code：${分组id},${基金code}
                  from: 'fund-detail-wechat', // 来源, plugin:插件, rn-optional:rn自选，fund-detail-wechat
                },
              },
            };
            // eslint-disable-next-line no-undef
            wx.miniProgram.postMessage({ data });
          }
        }
      }
      return true;
    } catch (error) {
      console.log('error', error);
      this.getFundOptionList(true);
      multi.$feedback.showToast({ title: '删除自选失败' });
      return false;
    }
  }

  // 置顶
  async setToTop(code) {
    try {
      const res = await Vue.prototype.$http.useRequests('OptionApi.setTop', {
        fCode: code,
        favorversion: this.fundVersionCode,
      });
      if (res?.success) {
        await this.getFundOptionList(true);
        console.log('fundGroupOptionList>>', this.fundGroupOptionList);
        const currentInfo = this.fundGroupOptionList?.[code] ?? [];
        const webPlatf = multi.$system.webPlatform;
        if (webPlatf === 'wxmp' && currentInfo?.length > 0) {
          // eslint-disable-next-line no-undef
          if (wx.miniProgram && wx.miniProgram.postMessage) {
            const { version } = res?.data;
            const data = {
              isGlobal: true,
              eventName: 'option_other_action_done',
              data: {
                easy_fund_top: { // 插件里才有，兼容weex
                  version,
                  data: currentInfo.map((item) => `${item},${code}`).join(';'), // -1和1748487951226是分组id，后面的968040是当前基金code，多个用;连接 ：${分组id},${基金code}
                  from: 'fund-detail-wechat', // 来源, plugin:插件, rn-optional:rn自选，fund-detail-wechat
                  isSetTop: true,
                  isToBottom: false,
                },
              },
            };
            // eslint-disable-next-line no-undef
            wx.miniProgram.postMessage({ data });
          }
        }
      }
      return true;
    } catch (error) {
      this.getFundOptionList(true);
      console.log('error>>>', error);
      multi.$feedback.showToast({ title: '置顶失败' });
      return false;
    }
  }
}
export default new OptionManager();
